import { buildBaseThemeMapping } from '../../shared/base-theme';
// dojo
import button from './dojo/button.m.css';
import checkbox from './dojo/checkbox.m.css';
import icon from './dojo/icon.m.css';
import label from './dojo/label.m.css';
import radio from './dojo/radio.m.css';
import tooltip from './dojo/tooltip.m.css';
// base-widgets
import accordion2 from './base-widgets/accordion2.m.css';
import slidingpane from './base-widgets/sliding-pane.m.css';
import tabcontainer from './base-widgets/tab-container.m.css';
// audio
import audio from './audio/audio.m.css';
// video
import video from './video/video.m.css';
// backview
import backview from './backview/backview.m.css';
// learning-activity
import activity from './learning-activity/activity.m.css';
// lcc-app
import content from './lcc-app/content.m.css';
import footer from './lcc-app/footer.m.css';
import heading from './lcc-app/heading.m.css';
import splash from './lcc-app/splash.m.css';
// lcc-rcs
import document from './lcc-rcs/document.m.css';
// book-widgets
import statusicon from './book-widgets/status-icon.m.css';
import topicaccordion from './book-widgets/topicaccordion.m.css';
import topicgroup from './book-widgets/topicgroup.m.css';
import topicpage from './book-widgets/topicpage.m.css';
// card
import card from './card/card.m.css';
import expanded from './card/expanded.m.css';
import tgf from './card/tgf.m.css';
// prepost-viz
import progress from './prepost-viz/progress-viz.m.css';
// quiz-widgets
import discussion from './quiz-widgets/discussion.m.css';
import flashcard from './quiz-widgets/flashcard.m.css';
import mcquestion from './quiz-widgets/mcquestion.m.css';
import pretestreview from './quiz-widgets/pretest-review.m.css';
import prometricreview from './quiz-widgets/prometric-review.m.css';
import prometric from './quiz-widgets/prometric.m.css';
import questionfeedback from './quiz-widgets/questionfeedback.m.css';
import quizfolder from './quiz-widgets/quizfolder.m.css';
import singlestep from './quiz-widgets/singlestep.m.css';
// landing-page
import welcomeview from './landing-page/welcome-view.m.css';
// explore-view widgets
import carouselview from './explore-view/carousel-view.m.css';
import chooser from './explore-view/chooser.m.css';
import contentorder from './explore-view/content-order.m.css';
import navcard from './explore-view/nav-card.m.css';
// variants
import epmVariant from './variants/epm.m.css';
import pmpVariant from './variants/pmp.m.css';

export default {
	theme: {
		...buildBaseThemeMapping({
			button,
			checkbox,
			label,
			icon,
			tooltip,
			radio,
			tabcontainer,
			accordion2,
			slidingpane,
			audio,
			video,
			backview,
			expanded,
			tgf,
			activity,
			heading,
			content,
			splash,
			footer,
			document,
			topicpage,
			topicgroup,
			topicaccordion,
			statusicon,
			progress,
			discussion,
			flashcard,
			mcquestion,
			pretestreview,
			prometricreview,
			prometric,
			questionfeedback,
			singlestep,
			quizfolder,
			welcomeview,
			contentorder,
			carouselview,
			chooser,
			navcard
		}),
		'card/card': card
	},
	variants: {
		pmp: pmpVariant,
		epm: epmVariant
	}
};
